import React from 'react'
import "./Loading.css"

const Loading = () => {
    return (
        <div id="loading" >
            {/* <svg
            width="486"
            height="460"
            viewBox="0 0 486 460"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
             >
                <rect
                x="345.776"
                y="25.1357"
                width="116.145"
                height="434.854"
                rx="58.0725"
                fill="#7068D3"
                fill-opacity="0.7"
                className="rect_3"
                />
                <rect
                x="15.9235"
                y="263.938"
                width="116.145"
                height="196.061"
                rx="58.0725"
                fill="#7068D3"
                fill-opacity="0.7"
                className="rect_4"
                />
                <rect
                width="121.007"
                height="358.18"
                rx="60.5034"
                transform="matrix(0.678698 -0.734418 0.678698 0.734418 0 89.9739)"
                fill="#7068D3"
                fill-opacity="0.7"
                className="rect_1"
                />
                <rect
                width="121.007"
                height="358.18"
                rx="60.5034"
                transform="matrix(0.678698 0.734418 -0.678698 0.734418 403.043 0)"
                fill="#7068D3"
                fill-opacity="0.7"
                className="rect_2"
                />
            </svg> */}
            <svg width="425" height="403" viewBox="0 0 425 403" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect className="rect_3" x="302.895" y="22.0183" width="101.741" height="380.925" rx="50.8705" fill="#625AC0" fill-opacity="0.83"/>
                <rect className="rect_4" x="13.9487" y="231.206" width="101.741" height="171.746" rx="50.8705" fill="#625AC0" fill-opacity="0.83"/>
                <rect className="rect_1" width="106" height="313.759" rx="52.9999" transform="matrix(0.678698 -0.734418 0.678698 0.734418 0 78.8154)" fill="#625AC0" fill-opacity="0.83"/>
                <rect className="rect_2" width="106" height="313.759" rx="52.9999" transform="matrix(0.678698 0.734418 -0.678698 0.734418 353.059 0)" fill="#625AC0" fill-opacity="0.83"/>
            </svg>

        </div>
    )
}

export default Loading
